import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {Select, Button} from "antd";

import './style.css';
import { PositionTypeContext } from '../../PositionAdd';
import {getPositionTypeByDivision} from "../../../../../newMediaMatrix/actions/actions";
// 获取antd Select属性
const InputProps = {
    ...Select.defaultProps, ...Select.propTypes, onChange: () => {
    }
}

/**
 * Select输入框
 */
class PlatformSelect extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            value: "",
            divisionName: "线上平台",
            divisionData: [],
        };
    }

    componentDidMount() {
        const observer = new ResizeObserver((e, o) => {
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        this.setState({
            value: this.props.fieldProps.value,
            divisionName: this.props.fieldProps.divisionName || "线上平台",
        },() => {
            this.getPlatformData();
        })
        if(this.props.fieldProps.value) {
            this.props.fieldProps.getExtendsField(this.props.fieldProps.value);
        }
    }

    componentWillUnmount() {
        this.setState = (state,callback)=>{
            return;
        };
    }

    getPlatformData() {
        getPositionTypeByDivision({divisionName: this.state.divisionName}, (data) => {
            let divisionData = [];
            if (data && data.length) {
                divisionData = data.map(item => {
                    return {
                        ...item,
                        key: item.id,
                        label: item.name
                    }
                })
            }
            this.setState({
                divisionData
            })
        })
    }

    static getDerivedStateFromProps(props, state) {
        // 判断props中的属性
        if (props.fieldProps && state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(PlatformSelect.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state, fieldProps: {...newProps}}
        }
        return state
    }

    renderSuffixButton() {
        const {buttonProps = {}} = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }

    getDivision() {
        return [
            {key: "线上平台", label: "线上平台"},
            {key: "线下平台", label: "线下平台"},
        ]
    }

    render() {
        const {prefixLayout, suffixLayout, style = {}, suffixButton, options, getExtendsField, platformDivide} = this.props.fieldProps;
        const {fieldProps, suffixWidth, divisionData} = this.state;
        const division = this.getDivision();
        return (
            <>
                <div className="rmt-input">
                    {
                        !!prefixLayout && <div className="rmt-input-prefix-layout">{prefixLayout}</div>
                    }
                    <div className="rmt-input-content-layout" style={style}>
                        <PositionTypeContext.Consumer>
                            {
                                value=>(
                                    <>
                                        {platformDivide ? null : <Select {...fieldProps} disabled={!!this.props.fieldProps.positionId}
                                            className="first-select" value={this.state.divisionName || undefined}
                                            style={{ width: "30%", marginRight: 15 }} onChange={(e) => {
                                                this.setState({ divisionName: e }, () => {
                                                    this.state.value = "";
                                                    // 修改formItem校验状态
                                                    typeof this.props.setFiledValidateStatus === 'function' && this.props.setFiledValidateStatus(undefined);
                                                    // typeof value.positionTypeOnChange === 'function'&&value.positionTypeOnChange({})
                                                    this.getPlatformData()
                                                })
                                            }}>
                                            {division.map(item => {
                                                return (
                                                    <Select.Option title={item.label}
                                                        key={item.key}>{item.label}</Select.Option>
                                                )
                                            })}
                                        </Select>}
                                        <Select getPopupContainer={triggerNode => triggerNode.parentElement} {...fieldProps} disabled={!!this.props.fieldProps.positionId} id={this.props.name} value={this.state.value || undefined} style={{ width: platformDivide ? "100%" : "65%" }} onChange={(e) => {
                                            this.setState({ value: e })
                                            fieldProps.onChange(e);
                                            typeof getExtendsField === "function" && getExtendsField(e);
                                            // typeof value.positionTypeOnChange === 'function'&&value.positionTypeOnChange(divisionData.find(item=>item.key===e))
                                        }}>
                                            {divisionData.map(item => {
                                                return (
                                                    <Select.Option title={item.label} key={item.key}>{item.label}</Select.Option>
                                                )
                                            })}
                                        </Select>
                                    </>
                                )
                            }
                        </PositionTypeContext.Consumer>
                    </div>
                    {
                        (!!suffixLayout && !suffixButton) &&
                        <div className="rmt-input-suffix-layout">{suffixLayout}</div>
                    }
                    {
                        (!!suffixButton && !suffixLayout) &&
                        <div className="rmt-input-suffix-layout">{this.renderSuffixButton()}</div>
                    }
                </div>
                <style>
                    {
                        `div[data-name = '${this.props.name}'] .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth > 0 ? suffixWidth : 35}px);
                        }`
                    }
                </style>
            </>
        )
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        }else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}

export default PlatformSelect;

PlatformSelect.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

PlatformSelect.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {
        options: [],
    },
}